import appSettingsIcon from './app-settings.svg';
import assessmentClassificationIcon from './assessment-classification.svg'
import assessmentCompletionIcon from './assessment-completion.svg';
import assessmentGrowthIcon from './assessment-growth.svg'
import configurationIcon from './configuration.svg';
import curriculumManagementIcon from './curriculum-management.svg';
import cutLineIcon from './cutline-configuration.svg';
import dataExtractsIcon from './data-extracts.svg';
import growthIcon from './growth.svg';
import readingRiskIcon from './reading-risk.svg';
import rosterManagementIcon from './roster-management.svg';
import sorpaIcon from './sorpa.svg';
import standardsAnalysisIcon from './standards-analysis.svg';
import usageIcon from './usage.svg';

export const routeIcons = {
  // Admin Reports
  assessmentCompletion: assessmentCompletionIcon,
  assessmentClassification: assessmentClassificationIcon,
  readingRisk: readingRiskIcon,
  assessmentGrowth: assessmentGrowthIcon,
  usage: usageIcon,
  growth: growthIcon,
  sorpa: sorpaIcon,
  standardsAnalysis: standardsAnalysisIcon,

  // Configuration & Set Up
  assessmentConfiguration: configurationIcon,
  screeningWindows: configurationIcon,
  curriculumManagement: curriculumManagementIcon,
  cutlineConfiguration: cutLineIcon,
  appSettings: appSettingsIcon,

  // Other Tools
  dataExtracts: dataExtractsIcon,
  rosterManagement: rosterManagementIcon,
};

// Type for route types
export type RouteIconType = keyof typeof routeIcons;
